import { useEffect, useState } from 'react';
import Table from 'src/MarketDataComponents/Table';
import Tabs from 'src/MarketDataComponents/Tabs';

export default function DocumentSection({documents}) {
    const [tabsProps, setTabsProps] = useState(null);

    useEffect(() => {
        let tabProps = {tabs: []};

        documents.map(docCat => {
            const theadRows = [
                <tr key={`headrow-${docCat.name}`}>
                    <th data-testid="documentsDocumentTypeTableHead">Document type</th>
                    <th data-testid="documentsLanguageTableHead">Language</th>
                    <th data-testid="documentsEffectiveDateTableHead">Effective date</th>
                    <th data-testid="documentsFileFormatTableHead">File format</th>
                </tr>
            ];

            const tabContent = <Table
                defaultClassName="data-table data-table--small data-table--scroll highlight margin-0"
                key={`table-${docCat.name}`}
                theadRows={theadRows}
                tbodyRows={
                    docCat.documents.map( (doc, i) => {
                        let icon;
                        if ( doc.fileFormat == 'HTM' ) {
                                icon = <i className="fas fa-file padding-right-5"></i>;
                        }
                        else if (doc.fileFormat == 'PDF' ) {
                            icon = <i className="fas fa-file-alt padding-right-5"></i>;
                        }
                        return(
                            <tr key={`${docCat.name}-${i}`}>
                                <td scope="row" aria-label="Document type" data-testid={`documentsDocumentTypeValue${i}`}>{doc.type}</td>
                                <td aria-label="Language" data-testid={`documentsLanguageValue${i}`}>{doc.language}</td>
                                <td aria-label="Effective date" data-testid={`documentsEffectiveDateValue${i}`}>{doc.effectiveDate}</td>
                                <td aria-label="File format" data-testid={`documentsFileFormatValue${i}`}>
                                    <a href={doc.url} className="text-underline-none" target="_blank" rel="noreferrer">
                                        {icon}
                                        {doc.fileFormat}
                                    </a>
                                </td>
                            </tr>
                        );
                    })
                }
            />;

            tabProps.tabs.push({
                label: <span style={{textTransform: "capitalize"}} data-testid={`documents${docCat.name}Tab`}>{docCat.name}</span>,
                content: tabContent
            });
        });

        setTabsProps(tabProps)
    }, []);

    return tabsProps ? <Tabs {...tabsProps} /> : null;
}